import React from "react";

const LogOutIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="log_out_icon"
      data-name="log out"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66675 10L5.83341 13.3334V10.8334H13.3334V9.16669H5.83341V6.66669L1.66675 10Z"
        fill={props.fill || "#EF5350"}
      />
      <path
        d="M10.8341 2.49917C9.8487 2.49644 8.87256 2.68927 7.96222 3.06648C7.05188 3.44369 6.22543 3.99779 5.53076 4.69667L6.70909 5.87501C7.81076 4.77334 9.27576 4.16584 10.8341 4.16584C12.3924 4.16584 13.8574 4.77334 14.9591 5.87501C16.0608 6.97667 16.6683 8.44167 16.6683 10C16.6683 11.5583 16.0608 13.0233 14.9591 14.125C13.8574 15.2267 12.3924 15.8342 10.8341 15.8342C9.27576 15.8342 7.81076 15.2267 6.70909 14.125L5.53076 15.3033C6.9466 16.72 8.82993 17.5008 10.8341 17.5008C12.8383 17.5008 14.7216 16.72 16.1374 15.3033C17.5541 13.8875 18.3349 12.0042 18.3349 10C18.3349 7.99584 17.5541 6.11251 16.1374 4.69667C15.4428 3.99779 14.6163 3.44369 13.706 3.06648C12.7956 2.68927 11.8195 2.49644 10.8341 2.49917V2.49917Z"
        fill={props.fill || "#EF5350"}
      />
    </svg>
  );
};

export default LogOutIcon;
